import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getSupperFundHome } from '../action/investmentAction';
import ModalSelect from './Modal/ModalSelect';

import { getStorage, setStorage } from '../common';
import { hashHistory } from 'react-router';
import {
  getPayAll,
  goHXJJLogin,
  goLogin
} from '../getPay';
class SubscriptionDetailTwo extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  callBack(){

  }
  componentWillMount() {
    let { dispatch } = this.props;
    dispatch(getSupperFundHome({},this.callBack,this))
  }
  goPay(){
    var params = {
      fundName: "华夏3年封闭运作战略配售",
      fundCode:'501186',
      businessType:'T020',
      productType:'G',
      fundType:'股票型',
      enterType:'SubscriptionDetail'
    }
    let fun=()=>{
      getPayAll(window.history.length,params, hashHistory, 'Payment')
    }
    goHXJJLogin(fun, window.history.length);
  }
  render(){
    let { SupperFundHome } = this.props;
    console.log(SupperFundHome);
    return (
        <div style={{flex:1}}>
          <div style={{width:window.screen.width, height:window.screen.width*(3312/640)}} className="SubscriptionDetailTwoBanner" >
            
          </div>
          <div style={{height:40, width:"100%"}}></div>
          <div onClick={()=>this.goPay()} style={{ position:"fixed", bottom:0, width:"100%", height:40, backgroundColor:"#fa063a", color:'#FFF', fontSize:'0.3rem',display: "-webkit-flex", WebkitJustifyContent:'center', WebkitAlignItems:'center' }}>
              <span>立即认购</span>
          </div>
          <ModalSelect/>
        </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  return {
    SupperFundHome:state.SupperFundHome
  }
}
export default connect(mapStateToProps)(SubscriptionDetailTwo);



// WEBPACK FOOTER //
// ./src/components/SubscriptionDetailTwo.js